function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { DateService } from "./date.service";
import { batch, range } from "./helpers";
const DEFAULT_DATE_OPTIONS = {
  bounding: false,
  holiday: false,
  range: false
};
export class CalendarDataService {
  constructor(dateService) {
    this.dateService = dateService;

    _defineProperty(this, "createDayPickerData", (date, dateRange) => {
      const weeks = this.createDates(date, DEFAULT_DATE_OPTIONS, dateRange);
      return this.withBoundingMonths(weeks, date);
    });

    _defineProperty(this, "createMonthPickerData", (date, rows, columns) => {
      const yearStart = this.dateService.getYearStart(date);
      const monthRange = range(rows * columns, index => {
        const monthDate = this.dateService.addMonth(yearStart, index);
        return _objectSpread({
          date: monthDate
        }, DEFAULT_DATE_OPTIONS);
      });
      return batch(monthRange, rows);
    });

    _defineProperty(this, "createYearPickerData", (date, rows, columns) => {
      const yearStart = this.dateService.getYearStart(date);
      const yearRange = range(rows * columns, index => {
        const yearDate = this.dateService.addYear(yearStart, index);
        return _objectSpread({
          date: yearDate
        }, DEFAULT_DATE_OPTIONS);
      });
      return batch(yearRange, rows);
    });

    _defineProperty(this, "createDayPickerPagerData", (startDate, endDate) => {
      const numberOfDayPickers = this.getNumberOfMonths(startDate, endDate) + 1;
      return range(numberOfDayPickers, index => {
        const monthDate = this.dateService.addMonth(startDate, index);
        return _objectSpread({
          date: monthDate
        }, DEFAULT_DATE_OPTIONS);
      });
    });

    _defineProperty(this, "createYearPickerPagerData", (startDate, endDate, rows, columns) => {
      const numberOfYears = this.getNumberOfYears(startDate, endDate) + 1;
      const numberOfYearPickers = Math.max(Math.ceil(numberOfYears / (rows * columns)), 1);
      return range(numberOfYearPickers, index => {
        const yearDate = this.dateService.addYear(startDate, index * rows * columns);
        return _objectSpread({
          date: yearDate
        }, DEFAULT_DATE_OPTIONS);
      });
    });

    _defineProperty(this, "getNumberOfMonths", (lhs, rhs) => {
      const numberOfYears = this.getNumberOfYears(lhs, rhs);
      const numberOfMonths = this.dateService.getMonth(rhs) - this.dateService.getMonth(lhs);
      return numberOfMonths + numberOfYears * DateService.MONTHS_IN_YEAR;
    });

    _defineProperty(this, "getNumberOfYears", (lhs, rhs) => {
      return this.dateService.getYear(rhs) - this.dateService.getYear(lhs);
    });
  }

  createDates(activeMonth, options, dateRange) {
    let days = this.createDateRangeForMonth(activeMonth, options);

    if (dateRange) {
      days = this.withRangedDates(days, dateRange);
    }

    const startOfWeekDayDiff = this.getStartOfWeekDayDiff(activeMonth);
    return batch(days, DateService.DAYS_IN_WEEK, startOfWeekDayDiff);
  }

  withRangedDates(days, calendarRange) {
    if (calendarRange.startDate && !calendarRange.endDate) {
      return this.withRangedStartDates(days, calendarRange.startDate);
    }

    if (calendarRange.startDate && calendarRange.endDate) {
      return this.withRangedStartEndDates(days, calendarRange.startDate, calendarRange.endDate);
    }

    return days;
  }

  withRangedStartDates(days, startDate) {
    return days.map(day => {
      const isSameStartDate = this.dateService.compareDatesSafe(day.date, startDate) === 0;
      return isSameStartDate ? _objectSpread(_objectSpread({}, day), {}, {
        range: true
      }) : day;
    });
  }

  withRangedStartEndDates(days, startDate, endDate) {
    return days.map(day => {
      const isSameStartDate = this.dateService.compareDatesSafe(day.date, startDate) === 0;
      const isSameEndDate = this.dateService.compareDatesSafe(day.date, endDate) === 0;

      if (isSameStartDate || isSameEndDate) {
        return _objectSpread(_objectSpread({}, day), {}, {
          range: true
        });
      } else {
        const isInRange = this.dateService.isBetween(day.date, startDate, endDate);
        return _objectSpread(_objectSpread({}, day), {}, {
          range: isInRange
        });
      }
    });
  }

  withBoundingMonths(weeks, activeMonth) {
    let withBoundingMonths = weeks;

    if (this.isShouldAddPrevBoundingMonth(withBoundingMonths)) {
      withBoundingMonths = this.addPrevBoundingMonth(withBoundingMonths, activeMonth);
    }

    if (this.isShouldAddNextBoundingMonth(withBoundingMonths)) {
      withBoundingMonths = this.addNextBoundingMonth(withBoundingMonths, activeMonth);
    }

    return withBoundingMonths;
  }

  addPrevBoundingMonth(weeks, activeMonth) {
    const firstWeek = weeks.shift();
    const numberOfBoundingDates = DateService.DAYS_IN_WEEK - firstWeek.length;
    firstWeek.unshift(...this.createPrevBoundingDays(activeMonth, numberOfBoundingDates));
    return [firstWeek, ...weeks];
  }

  addNextBoundingMonth(weeks, activeMonth) {
    const lastWeek = weeks.pop();
    const numberOfBoundingDates = DateService.DAYS_IN_WEEK - lastWeek.length;
    lastWeek.push(...this.createNextBoundingDays(activeMonth, numberOfBoundingDates));
    return [...weeks, lastWeek];
  }

  createPrevBoundingDays(activeMonth, numberOfBoundingDates) {
    const month = this.dateService.addMonth(activeMonth, -1);
    const daysInMonth = this.dateService.getNumberOfDaysInMonth(month);
    return this.createDateRangeForMonth(month, DEFAULT_DATE_OPTIONS).slice(daysInMonth - numberOfBoundingDates).map(date => {
      return _objectSpread(_objectSpread({}, date), {}, {
        bounding: true
      });
    });
  }

  createNextBoundingDays(activeMonth, numberOfBoundingDates) {
    const month = this.dateService.addMonth(activeMonth, 1);
    return this.createDateRangeForMonth(month, DEFAULT_DATE_OPTIONS).slice(0, numberOfBoundingDates).map(date => {
      return _objectSpread(_objectSpread({}, date), {}, {
        bounding: true
      });
    });
  }

  getStartOfWeekDayDiff(date) {
    const startOfMonth = this.dateService.getMonthStart(date);
    return this.getWeekStartDiff(startOfMonth);
  }

  getWeekStartDiff(date) {
    return (DateService.DAYS_IN_WEEK - this.dateService.getFirstDayOfWeek() + this.dateService.getDayOfWeek(date)) % DateService.DAYS_IN_WEEK;
  }

  isShouldAddPrevBoundingMonth(weeks) {
    return weeks[0].length < DateService.DAYS_IN_WEEK;
  }

  isShouldAddNextBoundingMonth(weeks) {
    return weeks[weeks.length - 1].length < DateService.DAYS_IN_WEEK;
  }

  createDateRangeForMonth(monthDate, options) {
    const daysInMonth = this.dateService.getNumberOfDaysInMonth(monthDate);
    return range(daysInMonth, i => {
      const year = this.dateService.getYear(monthDate);
      const month = this.dateService.getMonth(monthDate);
      const date = this.dateService.createDate(year, month, i + 1);
      return _objectSpread({
        date
      }, options);
    });
  }

}